import { render } from "./allstore.vue?vue&type=template&id=d48b06e6&scoped=true"
import script from "./allstore.vue?vue&type=script&lang=js"
export * from "./allstore.vue?vue&type=script&lang=js"

import "./allstore.vue?vue&type=style&index=0&id=d48b06e6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48b06e6"]])

export default __exports__